(function () {
  'use strict';

  var activeSelectionZones = new Set();

  function syncSelectionSnapState() {
    document.documentElement.classList.toggle('pm-footer-in-view', activeSelectionZones.size > 0);
  }

  /**
   * 首页 / PDP 的 html 有 scroll-snap 时，在 root 外的区块拖选会被当成滚动。
   * 鼠标进入或区块进视口时临时关闭 snap（与 footer 相同机制）。
   */
  function initSnapDisableForSelection(root) {
    var isLanding = !!document.querySelector('[data-pixelmob-root]');
    var isPdp = !!document.querySelector('.section-pdp-shell');
    if (!isLanding && !isPdp) return;
    if (!root || root.dataset.pmSelectionZoneBound === '1') return;
    root.dataset.pmSelectionZoneBound = '1';

    var intersecting = false;
    var hovering = false;

    function refreshZoneState() {
      if (intersecting || hovering) {
        activeSelectionZones.add(root);
      } else {
        activeSelectionZones.delete(root);
      }
      syncSelectionSnapState();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          intersecting = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          refreshZoneState();
        },
        { threshold: 0 }
      ).observe(root);
    }

    root.addEventListener('mouseenter', function () {
      hovering = true;
      refreshZoneState();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      refreshZoneState();
    });
  }

  function isMobileFooter() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function setAccordionOpen(accordion, open) {
    var content = accordion.querySelector('.pm-footer__accordion-content');
    var inner = accordion.querySelector('.pm-footer__accordion-content-inner');
    var btn = accordion.querySelector('.pm-footer__accordion-toggle');
    if (!content || !inner) return;

    if (open) {
      accordion.classList.add('is-open');
      content.style.height = inner.offsetHeight + 'px';
      requestAnimationFrame(function () {
        content.style.height = 'auto';
      });
      if (btn) btn.setAttribute('aria-expanded', 'true');
    } else {
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(function () {
        content.style.height = '0';
      });
      accordion.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  function initAccordions(root) {
    root.querySelectorAll('.pm-footer__accordion').forEach(function (accordion) {
      if (isMobileFooter() && !accordion.classList.contains('is-open')) {
        setAccordionOpen(accordion, true);
      }
    });

    root.querySelectorAll('.pm-footer__accordion-toggle').forEach(function (btn) {
      if (btn.dataset.pmFooterBound === '1') return;
      btn.dataset.pmFooterBound = '1';

      btn.addEventListener('click', function () {
        setAccordionOpen(btn.parentElement, !btn.parentElement.classList.contains('is-open'));
      });
    });
  }

  function initSelectionZones(scope) {
    (scope || document).querySelectorAll('[data-pm-selection-zone], [data-pm-footer]').forEach(function (root) {
      initSnapDisableForSelection(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-pm-footer]').forEach(function (root) {
      initAccordions(root);
    });
    initSelectionZones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target && e.target.querySelector('[data-pm-footer]');
    if (footer) {
      initAccordions(footer);
    }
    initSelectionZones(e.target);
  });
})();
